import * as THREE from 'three';

export function applyFogToScene(scene, env) {
  try {
    scene.fog = null;

    if (!env || !env.fog_checked) {
      return;
    }

    const fogType = env.fogType;
    let fogColor = 0xffffff;
    if (env.fogColor) {
      if (typeof env.fogColor === 'string') {
        const parsed = parseInt(env.fogColor.replace('#', ''), 16);
        const isExplicitBlack =
          env.fogColor.replace('#', '').toLowerCase() === '000000';
        fogColor =
          !isNaN(parsed) && (parsed !== 0 || isExplicitBlack)
            ? parsed
            : 0xffffff;
      } else if (typeof env.fogColor === 'number') {
        fogColor = env.fogColor;
      }
    }

    if (fogType === 'Linear' || fogType === 'Fog') {
      scene.fog = new THREE.Fog(
        fogColor,
        Number(env.fogStart) || 1,
        Number(env.fogEnd) || 1000
      );
    } else if (
      fogType === 'Exponential' ||
      fogType === 'Exponential Squared' ||
      fogType === 'Exp2' ||
      fogType === 'FogExp2'
    ) {
      scene.fog = new THREE.FogExp2(fogColor, Number(env.fog_density) || 0.01);
    }
  } catch (error) {
    console.error('Error applying fog:', error);
  }
}
